import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginApp } from '../../core/login/application/login.app';
import { Constants } from '../Constants';
import { ModelsService } from './model';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private modelService: ModelsService, private loginApp: LoginApp, protected injector: Injector) {
  }

  getConfiguredUrl(route: ActivatedRouteSnapshot): string {

    let path = '/' + route.pathFromRoot
      .filter(v => v.routeConfig)
      .map(v => v.routeConfig!.path)
      .join('/').replace("///", "/");
    return path;
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    try {

      if (this.modelService.user === null) {
        let user = await this.loginApp.getUser();
        if (user != null)
          this.modelService.user = user!;
      }

      if (this.modelService.user !== null) {

        const roles = (route.data["role"] ?? []) as Array<string>;

        if (roles.length > 0) {

          const role = roles.find((item) => {
            return item === this.modelService?.user?.role;
          });

          if (role === undefined) {
            let url = this.getConfiguredUrl(route);
            if (url == "/" || url.startsWith("/" + Constants.LAYOUT_HOME))
              this.router.navigate([Constants.LAYOUT_ACCESS_DENIED]);
            else
              this.router.navigate([Constants.LAYOUT_HOME]);
            return false;
          }
        }
        return true;
      }
    }
    catch (e) {
      this.router.navigate([Constants.LAYOUT_LOGIN]);
    }
    return false;
  }
}
